import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './daycareListDialog.module.scss'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Close } from '@mui/icons-material'
import { Daycare } from '@/types/Daycare'
import Desktop from '@/modules/desktopMobile/desktop'

interface DaycareListDialogProps {
    isDialogOpen: boolean
    handleCloseDialog: () => void
    daycares: Daycare[]
}

const DaycareListDialog: FunctionComponent<DaycareListDialogProps> = ({
    isDialogOpen,
    handleCloseDialog,
    daycares
}: DaycareListDialogProps) => {
    const { t } = useTranslation()

    return (
        <Dialog open={isDialogOpen} handleClose={handleCloseDialog} className={styles.Dialog}>
            <DialogHeader title={t('structureList')} />
            <DialogBody className={styles.DialogBody}>
                <TableContainer className={styles.TablePlacement}>
                    <Table className={styles.Table}>
                        <TableHead className={styles.TableHeader}>
                            <TableRow>
                                <TableCell>{t('name')}</TableCell>
                                <TableCell>{t('city')}</TableCell>
                                <Desktop>
                                    <TableCell>{t('email')}</TableCell>
                                    <TableCell>{t('phone')}</TableCell>
                                </Desktop>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {daycares.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={4}>{t('noDaycare')}</TableCell>
                                </TableRow>
                            ) : (
                                daycares.map(({ name, city, email, phone }, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{name ? name : <Close className={styles.CloseIcon} />}</TableCell>
                                        <TableCell>{city ? city : <Close className={styles.CloseIcon} />}</TableCell>
                                        <Desktop>
                                            <TableCell>
                                                {email ? (
                                                    <a href={`mailto:${email}`}>{email}</a>
                                                ) : (
                                                    <Close className={styles.CloseIcon} />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {phone ? (
                                                    <a href={`tel:${phone}`}>{phone.match(/.{1,2}/g)?.join(' ')}</a>
                                                ) : (
                                                    <Close className={styles.CloseIcon} />
                                                )}
                                            </TableCell>
                                        </Desktop>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleCloseDialog} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DaycareListDialog
